import React from "react"
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import {
    DatagridConfigurable,
    List,
    NumberField,
    //SearchInput,
    ReferenceField,
    TextField,
    usePermissions,
    ReferenceInput,
    SelectInput,
    TextInput,
    TopToolbar,
    FilterButton,
    ExportButton,
    Translate,
    SelectColumnsButton,
} from "react-admin"

const getEquipmentFilters = (permissions: string, translate: Translate): React.ReactElement[] => {
    const filters = [
        <TextInput source="name" label={translate("resources.paramsettings.fields.name")}/>,
        <TextInput source="varname" label={translate("resources.common.fields.varname")}/>,
        <TextInput source="label" label={translate("resources.paramsettings.fields.label")}/>,
        <ReferenceInput source="archive_type_id" reference="archive-types" label={translate("resources.paramsettings.fields.archive_type_id")}/>,
        <ReferenceInput source="unit_id" reference="units" label={translate("resources.paramsettings.fields.unit_id")}/>,
    ]
    if (permissions === "admin") {
        filters.push(<TextInput source="role" />)
    }
    return filters
}


const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <SelectColumnsButton />
        <ExportButton />
    </TopToolbar>
)

const EquipmenDriverParamList = () => {
    const { permissions } = usePermissions()
    const translate = useTranslate()
    const { id } = useParams<{ id: string }>()

    return (
        <List
            resource={`references/drivers/${id}/paramsettings`}
            filters={getEquipmentFilters(permissions, translate)}
            sort={{ field: "created_at", order: "DESC" }}
            title={translate('resources.equipmentdrivers.paramstitle')}
            actions={<ListActions />}
        >
            <DatagridConfigurable sx={{
                "& .RaDatagrid-headerCell": { 
                    fontWeight: 'bold' 
                },
            }} >
                <TextField source="name" label={translate("resources.paramsettings.fields.name")} />
                <TextField source="varname" label={translate("resources.common.fields.varname")}/>
                <TextField source="label" label={translate("resources.paramsettings.fields.label")}/>
                <ReferenceField label={translate("resources.paramsettings.fields.archive_type_id")} source="archive_type_id" reference="archive-types">
                    <TextField source="name" label={translate("resources.paramsettings.fields.archive_type_id")} />
                </ReferenceField>
                <ReferenceField label={translate("resources.paramsettings.fields.unit_id")} source="unit_id" reference="units">
                    <TextField source="name" label={translate("resources.paramsettings.fields.unit_id")} />
                </ReferenceField>
                <TextField source="data_column_name" label={translate("resources.paramsettings.fields.data_column_name")} />
                <TextField source="data_table_name" label={translate("resources.paramsettings.fields.data_table_name")} />
                <TextField source="data_type" label={translate("resources.paramsettings.fields.data_type")} />
                <NumberField source="decimal_places" label={translate("resources.paramsettings.fields.decimal_places")} />
            </DatagridConfigurable>
        </List>
    )
}

export default EquipmenDriverParamList